export default "__VITE_ASSET__CuhIJ4dC__"